
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqTaJ0ZNbER7zbnG0vaek2oc_45SEorEysxTzU3K3nU7Ho0Meta } from "/codebuild/output/src3740559815/src/src/pages/faq.vue?macro=true";
import { default as menufRmSsH_45yYdsu6_45oWzNFcBECkalszDPgPpmyKmQKp_453cMeta } from "/codebuild/output/src3740559815/src/src/pages/menu.vue?macro=true";
import { default as indexvzBF_m_450Bsq0T7__k9_NVCC_457_JBCntwdOXK2OFI_45tcMeta } from "/codebuild/output/src3740559815/src/src/pages/index.vue?macro=true";
import { default as contacthh5Z3pwUTUeTx1kNTiY1PTv4hCvIIDACWa3mETz7HfcMeta } from "/codebuild/output/src3740559815/src/src/pages/contact.vue?macro=true";
import { default as tutorialj4w8K_45qKdpI8kueX04nxPXO0Wjs2IP6RmlORstleH80Meta } from "/codebuild/output/src3740559815/src/src/pages/tutorial.vue?macro=true";
import { default as agreement24u4yzEaiDFkDKNgmrGgYnIVkufGP5mvHT3tVNelAb8Meta } from "/codebuild/output/src3740559815/src/src/pages/agreement.vue?macro=true";
import { default as about_45passbBQ_45NAThQNFlAHUpcRaTVHK9gnIlluBgylfNmikbwxsMeta } from "/codebuild/output/src3740559815/src/src/pages/about-pass.vue?macro=true";
import { default as indexZTl8RX7tgjvlQiPuEUeOZkWaokS0FzAqpJHTC2BgXfYMeta } from "/codebuild/output/src3740559815/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93yhhuHbQjpBRcnh_45NxkT0i2ugF4KdpLbPyPho38jujyQMeta } from "/codebuild/output/src3740559815/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancelJozgFgdO5F_g5g3MHfJSHqiCjUV_453UljLiKnklnHJwMeta } from "/codebuild/output/src3740559815/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93xM59JiSz5SKEwBWqXpYisFsj27rjJZPDu9jIhwr_5tYMeta } from "/codebuild/output/src3740559815/src/src/pages/notice/[id].vue?macro=true";
import { default as indexiXcy4_455baHXXASRJz6ylr8XjmbzAPq4G_uDJv_Jzbr0Meta } from "/codebuild/output/src3740559815/src/src/pages/coupon/index.vue?macro=true";
import { default as indexogfrsyFdT_45SuHgZuvCkN2B4pScHb5GgiTbgKbHcFjv8Meta } from "/codebuild/output/src3740559815/src/src/pages/mypage/index.vue?macro=true";
import { default as indexr_rZTT9MuSR23wx84klTU6NEIEekuhABXE2Yk_450wc0IMeta } from "/codebuild/output/src3740559815/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93gYBeFhM_6Dx8ujz3TSIJk_45p5ZQEHrEPXTxi4E6UrHHIMeta } from "/codebuild/output/src3740559815/src/src/pages/parking/[id].vue?macro=true";
import { default as indexJSXI2ku_45JWpC35wWmkmUNne0g_uIPP0SuftQLc5WmUsMeta } from "/codebuild/output/src3740559815/src/src/pages/history/index.vue?macro=true";
import { default as indexV0qu6XXPzn_45OWZX_45A8Eg_SMzpT0NHlZRB4OVCbVU6acMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/index.vue?macro=true";
import { default as indexqsmcFJxLgTd9EJqBI5G9hBNGOTjk3gLxLn6FFyEK_45WcMeta } from "/codebuild/output/src3740559815/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexorcZ0gvKy6ykGdKshvv7TawQGGsiRRKC5PY8WV4jSVUMeta } from "/codebuild/output/src3740559815/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavixkJgFXYWUl7GfKXYJ8l6lSG2i_6mjofGsUwbPiWEykMMeta } from "/codebuild/output/src3740559815/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editWAGBm__IwQ9xMR_45tPN8sCLRG3YzaA5qEQHDpwnKHif8Meta } from "/codebuild/output/src3740559815/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementr5N_RHEnF6jicMKES2V01n2lFQHKP9RV2Yj4CpUht2EMeta } from "/codebuild/output/src3740559815/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexSphTDBAgWxWZ4a3XDg7jI2nIv_R2wmJhnyzzSbRKgDsMeta } from "/codebuild/output/src3740559815/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453diiGUEDo3g1XfsvXkSHPWp97FxgwteUKrI2BKwf6j_451IMeta } from "/codebuild/output/src3740559815/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmWiu_45Gadpi1yCIaoX90RdNX0ZiZkWDvt2SvwrM8u8zj4Meta } from "/codebuild/output/src3740559815/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index_45RIqM2JVkQZFGBulPEM0GLxRW32HJospry3fsj8G3CYMeta } from "/codebuild/output/src3740559815/src/src/pages/card/create/index.vue?macro=true";
import { default as indexPrGZ8jEnBaxWk7Ls_QI4TTXZgMhRvwx_450dVb6G9F2roMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmpROCTUf9J46fohajycV8stkj_4sMrmcaqoFlAoYGXBcMeta } from "/codebuild/output/src3740559815/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmRLLydYRvbgB_45SFzgq3HHMTdC77JBSnARbWBN237ttWwMeta } from "/codebuild/output/src3740559815/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete741n_M_g4mcj97_45uCM4tje_87Vy_oKSy4G_45NOkw_454BIMeta } from "/codebuild/output/src3740559815/src/src/pages/membership/complete.vue?macro=true";
import { default as registerWFFnxGFXcmEWwBs6w6AMJFLvWbU9i8mJq4FPFqY7HGMMeta } from "/codebuild/output/src3740559815/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93Wx8d0JQsEG_w_fHAlia7E1dXg6CSKCVPVINKt8K7JR4Meta } from "/codebuild/output/src3740559815/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmqpLjn7Qp_X9SGreinm1QGvCIHnjFVLCmwLQlNxNK1xoMeta } from "/codebuild/output/src3740559815/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93RI8hL7aOWHcF24AVupgC9GgzquEEsvMesElx6S4OS1sMeta } from "/codebuild/output/src3740559815/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexJw80NJT7OpsvIWZ_qhYLmBfTERPnEcdzsLMmAj1umtMMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeQkchrnHP1UOvQfime3syKloHf_xszz2K59Mjoh7_45lncMeta } from "/codebuild/output/src3740559815/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45coden8_45wjLCoyVKiBMeel5TpQQ3ijfNoK8AByIIlrDVUznkMeta } from "/codebuild/output/src3740559815/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completesUoWB_hbfhnHPPC9QM5Y_45DFJPYttQwPyIRkpjcUuE_gMeta } from "/codebuild/output/src3740559815/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registergIMVtjXiYDtGHbtZhUk6VrxdAx22IJ3jbU_dl_xR7roMeta } from "/codebuild/output/src3740559815/src/src/pages/contact-form/register.vue?macro=true";
import { default as completei0ArzHSD359X78oF2klHA6Oc_45_6u6z3PE80TLg9XB6QMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexo0KQ1WmOvL60twiUTOpqfoU0nEN78MvgUHnoSRs0k5wMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmgoiMtIPBB3RvUAJcOM7DtMdLOH4akAIJZ6rpwFEcg1YMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeI52FxFOp2Ok1dl8Ap6HEMf8n2aDwmKTE6rX1qbHpMpwMeta } from "/codebuild/output/src3740559815/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexs0hAh_45XNZJHA9dWm_459aZYb_45d6D0Y2IHBt96Ss5fvwwAMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_936isc8wdFJGfxjz3vKpMf_56E7ZqWom2RV5gxSwhhO98Meta } from "/codebuild/output/src3740559815/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_459XJ_454K9811AwnDJKOeM95m_9kAaYaylTR_45RXMTJBEIMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasjyZDhnTlLUpJW2hozQoaDRF4cF7cxI3IBfDFgdTVRsgMeta } from "/codebuild/output/src3740559815/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample7G8yrSQmP257q8zSflOE4a1IFqHAE45DplVp7jWcebAMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailLqtS7f6SaAwrktG4gqMYLMUUCiIRYTT1yGLhIZ9KOT8Meta } from "/codebuild/output/src3740559815/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmLnCTxEgdmCO1VxYOA1S6rFgNrfG6zBMZC4AU4bllnI0Meta } from "/codebuild/output/src3740559815/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentkn_VhcVph74idM6osWq5kdW3S8SyGs93qmX_452RQSvsIMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmOkOBxb6OTaIEOSnCoxCwyvzyHxJi84JdAcTcxVKwLicMeta } from "/codebuild/output/src3740559815/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateyH2fnK_45tg7_457ItdG2kfbYmEaVY9Db6LVCsnUaPhCn8EMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete3nbV_rfz49dK2nxaGLxCqCkbxjrBbtYszQ_45CJwfLsxAMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeB8glEq9Vm_459sUhuR95oym4dt6W3y8iFMlR6AbZC9OlcMeta } from "/codebuild/output/src3740559815/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordL1YZmq0o_oHAImBZFw9WSi2ih6lErkXGsSyw5BP8zs4Meta } from "/codebuild/output/src3740559815/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasXFrPqX_ZU1J7ZP_aIRUIHEMhTrEL9tjfpvHVl28U_45tQMeta } from "/codebuild/output/src3740559815/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerTAend0jc3p8dBsy4uC_fUOeXi8GrZ1mWNfRSCYlZhLAMeta } from "/codebuild/output/src3740559815/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeXsiMszPRSHOnh_45G5TzHeIXFa6xZXz_45oc8q3lLO90BckMeta } from "/codebuild/output/src3740559815/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexdA7j777QW0hPpyQ7phzJrmILLfRX6pV6JVWrxUk2HVEMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexa6rQMRxIjqJK9jju750w2ZCT6gtUwNARxUVUDzOxjCwMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index3PEFL9DlBNWzA_Ksft0clkEnQRSEFThbHF9KV7pIkkMMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexZGxEJVH4WaxtavGDYtEUAZdKypFBjy0RwU1yB_45KxngQMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update7J8r8ZveMrrn9Jxxc_45NURWxAjhHpjwPL_JTUunq4L8kMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeKDZ_97pDK5YBGmP2NsTRGyDQ4QVcmkxHb_qTJ2AsGfsMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm1WqzakD37tVEo7bmwg8g6lFAFXGg_45bHr2OwRkRlTQPsMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexcyGK8X_452_45Lf4nJsWYcFtI4e6h1bsi5Y5kpQJ1dvUW1AMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeJklMsVx_f20RuogPcR0r100TKtNFzfduvp6MiBUSn44Meta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatew9lgv6ltyBLlDL4p7LRlTm_4555B7TmsH_45UiGATlOvUNYMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexBODQ2XmObRqmWXnnswc1YPCWNJM0bMmtaIphsvioJMkMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexi9vX_45oQjKMUn4XnQWenBG80Ba5bxPtIDT8l5YwPabvAMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete0ZYwuAhXbHebRJh6DLWco7nByhS3aTZjUA6lJuaityQMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexrPtDtl0Wmss4ExnfH4jq90cOCSwgCPVfLp7slDJGfLQMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code3rncPZpkQ1vmtbE7fQLSc3Piu60AVu8qKQFUu6EjmisMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexiY8NMkAquHppCTBEYkn0bZoQXUosnOm91X3IIiIA0E8Meta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexJPP7HJXZuOqystngVBRxL_45zvWbK8A7d2hSbk1wprJCwMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index3bKOQBj37rXWtgP3I_gGj5lkrsdLCMW8m0Nb_z3ov0YMeta } from "/codebuild/output/src3740559815/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatejZ1hXbBvdoZ9DEaHpqT0FaU5Nx_45mRVeTrpmaU47n_bsMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmOEFeahIQieEGyGTGI8AGLILLUkhDvFK2O5_45RvCUTrtoMeta } from "/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menufRmSsH_45yYdsu6_45oWzNFcBECkalszDPgPpmyKmQKp_453cMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexvzBF_m_450Bsq0T7__k9_NVCC_457_JBCntwdOXK2OFI_45tcMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexiXcy4_455baHXXASRJz6ylr8XjmbzAPq4G_uDJv_Jzbr0Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexJSXI2ku_45JWpC35wWmkmUNne0g_uIPP0SuftQLc5WmUsMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexqsmcFJxLgTd9EJqBI5G9hBNGOTjk3gLxLn6FFyEK_45WcMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexorcZ0gvKy6ykGdKshvv7TawQGGsiRRKC5PY8WV4jSVUMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index_45RIqM2JVkQZFGBulPEM0GLxRW32HJospry3fsj8G3CYMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmpROCTUf9J46fohajycV8stkj_4sMrmcaqoFlAoYGXBcMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmRLLydYRvbgB_45SFzgq3HHMTdC77JBSnARbWBN237ttWwMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete741n_M_g4mcj97_45uCM4tje_87Vy_oKSy4G_45NOkw_454BIMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerWFFnxGFXcmEWwBs6w6AMJFLvWbU9i8mJq4FPFqY7HGMMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmqpLjn7Qp_X9SGreinm1QGvCIHnjFVLCmwLQlNxNK1xoMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeQkchrnHP1UOvQfime3syKloHf_xszz2K59Mjoh7_45lncMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45coden8_45wjLCoyVKiBMeel5TpQQ3ijfNoK8AByIIlrDVUznkMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completesUoWB_hbfhnHPPC9QM5Y_45DFJPYttQwPyIRkpjcUuE_gMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registergIMVtjXiYDtGHbtZhUk6VrxdAx22IJ3jbU_dl_xR7roMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmgoiMtIPBB3RvUAJcOM7DtMdLOH4akAIJZ6rpwFEcg1YMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeI52FxFOp2Ok1dl8Ap6HEMf8n2aDwmKTE6rX1qbHpMpwMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexs0hAh_45XNZJHA9dWm_459aZYb_45d6D0Y2IHBt96Ss5fvwwAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_459XJ_454K9811AwnDJKOeM95m_9kAaYaylTR_45RXMTJBEIMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample7G8yrSQmP257q8zSflOE4a1IFqHAE45DplVp7jWcebAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailLqtS7f6SaAwrktG4gqMYLMUUCiIRYTT1yGLhIZ9KOT8Meta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmLnCTxEgdmCO1VxYOA1S6rFgNrfG6zBMZC4AU4bllnI0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentkn_VhcVph74idM6osWq5kdW3S8SyGs93qmX_452RQSvsIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmOkOBxb6OTaIEOSnCoxCwyvzyHxJi84JdAcTcxVKwLicMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete3nbV_rfz49dK2nxaGLxCqCkbxjrBbtYszQ_45CJwfLsxAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeB8glEq9Vm_459sUhuR95oym4dt6W3y8iFMlR6AbZC9OlcMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordL1YZmq0o_oHAImBZFw9WSi2ih6lErkXGsSyw5BP8zs4Meta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerTAend0jc3p8dBsy4uC_fUOeXi8GrZ1mWNfRSCYlZhLAMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeXsiMszPRSHOnh_45G5TzHeIXFa6xZXz_45oc8q3lLO90BckMeta || {},
    component: () => import("/codebuild/output/src3740559815/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3740559815/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]